export const eventGroupState = $state([]);

/**
 * Resets the event group state to an empty array without reassigning the state variable
 */
export function resetEventGroupState() {
    // Clear the array by setting its length to 0
    eventGroupState.length = 0;
}

/**
 * Sets the event group state with the provided array of event groups
 * @param {Array} eventGroups - The array of event groups to set in the state
 */
export function setEventGroupState(eventGroups) {
    // Clear existing event groups first
    resetEventGroupState();
    eventGroups.forEach(eventGroup => {
        eventGroupState.push({
            ...eventGroup
        })
    })
}